module.exports = require('./helpers/bundle-url').getBundleURL('hB35s') + "logo.c51670a8.svg";